export function shouldOpenConsoleAfterBulkSpam(createdCount: number): boolean {
	return createdCount > 0;
}

export function formatBulkSpamOutcome(result: {
	created: readonly unknown[];
	skipped: readonly unknown[];
	errors: readonly unknown[];
}): string {
	const skipped = result.skipped.length + result.errors.length;
	return `Запущено: ${result.created.length}. Пропущено: ${skipped}`;
}

/** Один id и пачка сохраняются одним zip, не `{id}.session`. */
export function senderSessionsExportFileName(sessionIds: readonly string[]): string {
	const single = sessionIds.length === 1;
	return single ? 'sender-sessions.zip' : 'sender-sessions.zip';
}
